// type : b-icon
export default {
    "slack": "slack",
    "mail": "inboxes-fill",
    "rocketchat": "chat-text",
}